import { Component } from '@angular/core';
import { ColumnFilterService } from 'src/app/shared/service/column-filter.service';

@Component({
  selector: 'app-clear-filter',
  templateUrl: './clear-filter.component.html',
  styleUrls: ['./clear-filter.component.scss']
})
export class ClearFilterComponent {

  constructor(private columnFilterService: ColumnFilterService) { }

  clearAllFilter(): void {
    this.columnFilterService.clearAllColumnFilters();
  }
}
